import React, { useState } from 'react';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { Label } from '../../components/Label';
import api from '../../services/api';
import { toast } from 'sonner';

interface MenuNovoUsuarioProps {
  onClose: () => void;
  onSuccess: () => void;
}

export const MenuNovoUsuario: React.FC<MenuNovoUsuarioProps> = ({ onClose, onSuccess }) => {
  const [nome, setNome] = useState('');
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nome.trim() || !login.trim() || !senha.trim()) {
      toast.error('Preencha todos os campos');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/v1/usuarios/', { nome, login, senha });
      toast.success('Usuário cadastrado com sucesso!');
      setNome('');
      setLogin('');
      setSenha('');
      onSuccess();
      onClose();
    } catch (err) {
      toast.error('Erro ao cadastrar usuário');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="menu-novo-material-overlay">
      <div className="menu-novo-material">
        <h3 className="menu-novo-material-title">Novo Usuário</h3>
        <form onSubmit={handleSubmit}>
          <Label htmlFor="novo-usuario-nome">Nome</Label>
          <Input
            id="novo-usuario-nome"
            value={nome}
            onChange={e => setNome(e.target.value)}
            placeholder="Digite o nome"
            autoFocus
          />
          <Label htmlFor="novo-usuario-login">Login</Label>
          <Input
            id="novo-usuario-login"
            value={login}
            onChange={e => setLogin(e.target.value)}
            placeholder="Digite o login"
          />
          <Label htmlFor="novo-usuario-senha">Senha</Label>
          <Input
            id="novo-usuario-senha"
            type="password"
            value={senha}
            onChange={e => setSenha(e.target.value)}
            placeholder="Digite a senha"
          />
          <div className="menu-novo-material-actions">
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? 'Salvando...' : 'Cadastrar'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
